import { render, staticRenderFns } from "./BuyHistoryModal.vue?vue&type=template&id=36c7549a&"
import script from "./BuyHistoryModal.vue?vue&type=script&lang=js&"
export * from "./BuyHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports